export default {
  // Home page
  home: {
    title: 'GWOFY',
    subtitle: 'Cross-Border E-Commerce Service Provider',
    hero: {
      eyebrow: 'GWOFY',
      title: 'Cross-Border E-Commerce Service Provider',
      subtitle: 'Logistics, freight forwarding, overseas warehousing, buyer protection, and On-Chain Data verification — one integrated partner for merchants and institutional collaborators.',
      ctaGooval: 'Explore Gooval',
      ctaContact: 'Contact Us',
      imageLabel: 'Hero image',
      imageKeyword: 'global logistics warehouse shipping containers aerial view modern'
    },
    services: {
      title: 'Our Services',
      subtitle: 'From fulfillment to freight coordination, warehousing, and On-Chain Data verification for merchants and partners.',
      imageLabel: 'Service image',
      logistics: {
        title: 'Cross-Border Logistics',
        description: 'Last-mile delivery, transit lanes, and end-to-end tracking to improve fulfillment efficiency and buyer experience.',
        keyword: 'cross border last mile delivery parcel tracking modern courier'
      },
      freight: {
        title: 'Freight Forwarding',
        description: 'First-mile transport, customs coordination, and multi-channel trunk line connectivity across your supply chain.',
        keyword: 'freight forwarding cargo ship port containers customs clearance'
      },
      warehouse: {
        title: 'Warehousing',
        description: 'Overseas inventory, inbound/outbound operations, and stock coordination for multi-platform operations.',
        keyword: 'fulfillment warehouse shelves inventory management'
      },
      blockchain: {
        title: 'On-Chain Data',
        description: 'On-chain verification for cross-border receivables and core transaction data with tamper-proof proofs.',
        keyword: 'blockchain data verification network nodes secure ledger technology'
      }
    },
    blockchain: {
      label: 'Featured Product',
      title: 'On-Chain Data — Blockchain Verification',
      subtitle: 'On-chain verification for cross-border receivables and core transaction data to strengthen transparency and institutional trust.',
      description: 'With merchant authorization, core operational data is encrypted and recorded on-chain so partners can verify authenticity and integrity in real time.',
      imageLabel: 'On-Chain Data product image',
      imageKeyword: 'blockchain data verification network nodes secure ledger technology',
      cta: 'View On-Chain Data',
      features: {
        feature1: {
          title: 'Data Authorization & On-Chain Recording',
          description: 'Merchants authorize API sync of core data, encrypted on-chain for authenticity and immutability.'
        },
        feature2: {
          title: 'Receivables Verification',
          description: 'On-chain verification of receivables generates trusted proofs and reduces information asymmetry.'
        },
        feature3: {
          title: 'Real-Time Institutional Verification',
          description: 'Partners can independently verify merchant data to improve credit and risk workflows.'
        },
        feature4: {
          title: 'Multi-Chain Support',
          description: 'Supports public chain ecosystems including Ethereum, Polygon, Solana, and Avalanche.'
        }
      }
    },
    gooval: {
      label: 'Featured Product',
      title: 'Gooval — Logistics & Buyer Protection',
      subtitle: 'Shipping protection and buyer benefit packages for DTC and cross-border merchants. Free for merchants — funded by shoppers who opt in.',
      imageLabel: 'Gooval product image',
      imageKeyword: 'ecommerce checkout shipping protection shield package insurance UI mockup',
      shopify: 'Shopify App',
      openApi: 'Open API Docs',
      features: {
        feature1: {
          title: 'Shipping Protection',
          description: 'Coverage for lost, damaged, and stolen packages to reduce disputes and support load.'
        },
        feature2: {
          title: 'Buyer Benefit Package',
          description: 'Returns, exchanges, and extended warranty options that improve conversion and retention.'
        },
        feature3: {
          title: 'One-Click Shopify Setup',
          description: 'Install via the Shopify App Store for checkout and cart experiences.'
        },
        feature4: {
          title: 'Open API Integration',
          description: 'Connect custom storefronts and internal systems through documented APIs.'
        }
      }
    },
    insurance: {
      label: 'Featured Product',
      title: 'Jiwu Antu - Amazon Overseas Warehouse Cargo Damage Protection',
      subtitle: 'Insurance solutions designed for cross-border logistics and commerce scenarios.',
      description: 'Coverage terms and product details are subject to the official partnership page. Merchants and partners are welcome to learn more.',
      imageLabel: 'Insurance product image',
      imageKeyword: 'business insurance partnership shield document professional office',
      cta: 'View Partnership Product',
      features: {
        feature1: 'Licensed insurance partnership for stronger trust in trade and fulfillment',
        feature2: 'Built for cross-border logistics and e-commerce use cases',
        feature3: 'Available for merchants and institutional partners on request'
      }
    },
    financing: {
      label: 'Financial Service',
      title: 'Cross-Border E-Commerce Accounts Receivable Financing',
      subtitle: 'Financing support for cross-border e-commerce receivables to help merchants improve cash flow.',
      description: 'We hold a Hong Kong Money Lenders Licence and provide accounts receivable financing services for eligible cross-border e-commerce merchants. Financing terms, limits, and approval requirements are subject to formal agreements.',
      imageLabel: 'Financing service image',
      imageKeyword: 'cross border ecommerce accounts receivable financing cash flow business capital professional office blue teal',
      licenseLabel: 'Money Lenders Licence No.',
      licenseNumber: '6675',
      warning: 'Warning: You have to repay your loans. Don\'t pay any intermediaries.',
      cta: 'Contact Us About Financing',
      features: {
        feature1: 'Designed for cross-border e-commerce receivables scenarios',
        feature2: 'Operated under a Hong Kong Money Lenders Licence',
        feature3: 'Consultation available for merchants seeking working-capital support'
      }
    },
    whyChoose: {
      title: 'Why GWOFY',
      items: {
        item1: {
          title: 'One-Stop Services',
          description: 'Logistics, freight, warehousing, On-Chain Data, and buyer protection coordinated under one partner.'
        },
        item2: {
          title: 'Productized Integration',
          description: 'Gooval ships with a Shopify app and Open API for faster go-live.'
        },
        item3: {
          title: 'Insurance Backing',
          description: 'Partnership with Cathay Insurance to support protection across the cross-border chain.'
        },
        item4: {
          title: 'Hong Kong Team',
          description: 'Experienced in cross-border e-commerce and international collaboration.'
        }
      }
    },
    banner: {
      mainTitle: 'On-Chain Verification for Cross-Border E-Commerce Receivables',
      subtitle1: 'Enhancing transparency and trust through on-chain verification,',
      subtitle2: 'providing reliable infrastructure for merchants and financial institutions',
      learnMore: 'Project doc',
      contactUs: 'Contact us'
    },
    vision: {
      mainTitle: 'Anchor on real data to make e-commerce more transparent and trustworthy',
      subtitle: 'Establish the on-chain standard for cross-border e-commerce receivables, bridging merchants and financial institutions',
      button: 'View On-Chain Data'
    },
    market: {
      mainTitle: 'China\'s cross-border e-commerce exceeds USD 500B annually, but merchants face persistent funding pain points:',
      subtitle: '**The absence of transparent data verification prevents institutions from providing adequate support',
      features: {
        feature1: {
          title: '⏳ Slow Settlements',
          description: '60–90 days of delayed cash flow'
        },
        feature2: {
          title: '💸 Tight Margins',
          description: '30% of merchants operate below 10% profit'
        },
        feature3: {
          title: '🚫 Growth Constraints',
          description: 'Annual turnover is limited to 4 cycles, limiting expansion'
        },
        feature4: {
          title: '⚠️ High Risk',
          description: 'Seasonal restocking and warehousing costs trigger sudden liquidity crises'
        }
      }
    },
    dataBridge: {
      mainTitle: 'Our Solution: A Data Bridge',
      mainTitleEn: 'Our Solution: A Data Bridge',
      features: {
        feature1: {
          title: 'On-Chain Data Verification',
          titleEn: 'On-Chain Data Verification',
          description: 'Merchants authorize API access to sync core operational data, which is then encrypted and recorded on-chain, ensuring authenticity and tamper-proofness',
          descriptionEn: 'Merchants authorize API access to sync core operational data, which is then encrypted and recorded on-chain, ensuring authenticity and tamper-proofness'
        },
        feature2: {
          title: 'Enhanced Transparency',
          titleEn: 'Enhanced Transparency',
          description: 'On-chain verification of receivables generates trusted proofs and reduces information asymmetry',
          descriptionEn: 'On-chain verification of receivables generates trusted proofs and reduces information asymmetry'
        },
        feature3: {
          title: 'Technical Strengths',
          titleEn: 'Technical Strengths',
          description: 'Hash validation ｜ Real-time updates ｜ Privacy protection',
          descriptionEn: 'Hash validation ｜ Real-time updates ｜ Privacy protection'
        }
      }
    },
    onChainData: {
      title: 'Gwofy <strong>periodically packages merchant data on-chain</strong>, ensuring authenticity and immutability<br/>Institutional partners can verify receivables data in real time, strengthening <strong>transparency and trust</strong>',
      button: 'View On-Chain Data'
    },
    merchantOnboarding: {
      title: 'Merchant Onboarding',
      step1: {
        title: 'Application',
        description: 'Submit application data'
      },
      step2: {
        title: 'Eligibility Review',
        description: 'Select merchants with stable operations and compliance records'
      },
      step3: {
        title: 'Data Integration',
        description: 'Merchant authorize APIs for real-time sync'
      },
      step4: {
        title: 'Verified on-chain',
        description: 'Data encrypted and verified on-chain by every hour'
      }
    },
    safeguards: {
      mainTitle: 'Platform Safeguards',
      features: {
        feature1: {
          title: 'Continuous Monitoring',
          description: 'Daily updates of merchant performance and credit conditions'
        },
        feature2: {
          title: 'Risk Detection',
          description: 'On-chain alerts for high return rates, abnormal fees, or risky behavior'
        },
        feature3: {
          title: 'Regulatory Compliance',
          description: 'Full adherence to KYC ｜ AML ｜ GDPR ｜ Hong Kong Privacy Ordinance'
        }
      }
    },
    partnerships: {
      mainTitle: 'Partnerships & Outlook',
      payments: {
        title: 'Payments & Settlement: ',
        description: 'Integration with banks and payment providers'
      },
      data: {
        title: 'Data Expansion: ',
        description: 'From Amazon to Shopify, eBay, and other global platforms'
      },
      financial: {
        title: 'Institutional Collaboration: ',
        description: 'Delivering verifiable on-chain data to banks and asset managers'
      }
    },
    founder: {
      title: 'Founder & CEO'
    },
    contact: {
      title: 'Contact Us',
      name: 'Name:',
      email: 'Email:',
      companyName: 'Company Name:',
      comment: 'Message:',
      submit: 'Contact Now',
      nameRequired: 'Name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Please enter a valid email address',
      companyNameRequired: 'Company name is required',
      commentRequired: 'Message is required',
      submitSuccess: 'Form submitted successfully!',
      networkError: 'Network error, please try again later',
      submitting: 'Submitting...'
    }
  },

  // RWA page
  rwa: {
    title: 'Asset Token Details',
    backToList: 'Back to Asset List',
    tableHeaders: {
      storeId: 'Store ID',
      orderId: 'Order ID',
      amount: 'Amount',
      signTime: 'Sign Time',
      expectedPaymentTime: 'Expected Payment Time',
      token: 'Token ID',
      time: 'Time',
      assetProof: 'Asset Proof'
    },
    stats: {
      tokenScale: 'Token Scale',
      totalStakeScale: 'Total Stake Scale',
      coinsDistribution: 'Coins Distribution Total'
    },
    listTitle: 'Asset Token List',
    datePicker: {
      selectDate: 'Select Date:',
      startDate: 'Start Date',
      endDate: 'End Date',
      to: 'to',
      confirm: 'Confirm',
      cancel: 'Cancel',
      selectStartDate: 'Select Start Date',
      selectEndDate: 'Select End Date'
    },
    errors: {
      loadFailed: 'Data loading failed',
      retry: 'Retry',
      noData: 'No data'
    }
  },

  // HomeLayout
  homeLayout: {
    header: {
      products: 'Featured Products',
      gooval: 'Gooval',
      insurance: 'Insurance Partnership',
      blockchain: 'On-Chain Data',
      openMenu: 'Open products menu',
      closeMenu: 'Close products menu'
    },
    footer: {
      subtitle: 'Cross-Border E-Commerce Service Provider',
      products: 'Related Products',
      about: 'About Us',
      whitepaper: 'Whitepaper',
      copyright: 'Copyright©2025 GWOFY',
      contactInfo: 'Contact Information:',
      email: 'Email:',
      address: 'Address: 12F, Shing Lee Yuen Building, 71 Bonham Strand W, Sheung Wan, Hong Kong',
      aboutUs: 'About Us',
      whitePaper: 'White paper',
      termsOfUse: 'Terms of use',
      complianceDisclaimer: 'Compliance Disclaimer',
      disclaimer1: 'Gwofy provides information on cross-border e-commerce services, including logistics, freight forwarding, warehousing, Gooval, insurance partnerships, On-Chain Data blockchain verification, and <strong>cross-border e-commerce accounts receivable financing</strong>. Nothing on this website constitutes an offer or solicitation to buy or sell securities, tokens, or other regulated products, nor financial or investment advice',
      disclaimer2: 'Platform services are primarily intended for <strong>cross-border e-commerce merchants, supply chain partners, and qualified institutional collaborators</strong>. Certain products may be limited to professional investors or eligible parties. Retail investors and residents from restricted jurisdictions —— including Hong Kong (non-professional investors), Mainland China, the United States, Canada, India, South Korea, and any other regions where such participation is prohibited —— may not use restricted products',
      disclaimer3: 'Use of services involves risks. Relevant users or partners may be required to complete <strong>KYC/AML checks</strong> and ensure compliance with applicable laws in their jurisdiction',
      license: 'Money Lenders Licence No.: <strong>6675</strong>',
      warning: 'Warning: You have to repay your loans. Don\'t pay any intermediaries.'
    }
  },

  // Terms of Use page
  termsOfUse: {
    title: 'Terms of Use',
    effectiveDate: 'Effective Date: 16.07.2026',
    welcome: 'Welcome to Gwofy (the "Platform" or "we"). The Platform is operated by GWOFY HK LIMITED and provides information about cross-border e-commerce services, including logistics, freight forwarding, overseas warehousing, the Gooval shipping and buyer protection product, insurance partnership offerings, and On-Chain Data blockchain verification. By using this website, you agree to the following Terms.',
    sections: {
      scope: {
        title: '1. Scope of Application',
        content: 'These Terms apply to all visitors and entities who access this website, review Platform information, or learn about, apply for, or integrate related services and partnership products. If you do not agree, please discontinue use immediately.'
      },
      noOffer: {
        title: '2. Service Description and No Investment Offer',
        points: [
          'All content on this website is provided for <strong>general information and business introduction only</strong> and does not constitute an offer, solicitation, or recommendation to buy or sell securities, tokens, insurance contracts, or other regulated financial products.',
          'The scope, pricing, coverage, and integration terms of logistics, freight, warehousing, Gooval, insurance partnership products, and On-Chain Data blockchain verification are governed by formal agreements, official partner pages, or applicable product terms.',
          'The Platform does not provide legal, financial, tax, or investment advice. You should seek independent professional advice before making business decisions.'
        ]
      },
      investorEligibility: {
        title: '3. Service Eligibility',
        content1: 'Platform services are primarily intended for <strong>cross-border e-commerce merchants, logistics and supply chain partners, and insurance or financial institutions</strong>.',
        content2: 'Certain partnership products, especially insurance-related or institutional data verification services, may only be available to qualified institutions, professional investors, or users permitted in specific jurisdictions. Users from the following jurisdictions may not use relevant products or services where prohibited by local law, including but not limited to:',
        prohibitedJurisdictions: [
          'Hong Kong (non-professional investors, where products are limited to professional investors)',
          'Mainland China (where local law restricts such services)',
          'United States, Canada, India, South Korea',
          'Any other jurisdiction where similar products or services are prohibited by law'
        ],
        verification: 'Where merchant onboarding, insurance partnerships, On-Chain Data authorization, fund handling, or compliance-related services are involved, users or partners may be required to complete <strong>KYC/AML</strong> or other compliance reviews.'
      },
      userResponsibilities: {
        title: '4. User Responsibilities',
        content: 'By using this website, you agree:',
        responsibilities: [
          'To provide accurate, complete, and up-to-date business and contact information',
          'Not to use this website, the Gooval app, Open API, On-Chain Data, or third-party partnership products for unlawful purposes',
          'Not to circumvent Platform security, compliance, review, or data protection measures',
          'To bear sole responsibility for consequences arising from your use of website information, third-party products, or business decisions'
        ]
      },
      riskDisclaimer: {
        title: '5. Risk Disclaimer',
        risks: [
          'Cross-border logistics, freight forwarding, warehousing, and fulfillment services may be affected by <strong>transport delays, customs policy changes, inventory volatility, partner operations, and regulatory changes</strong>.',
          'Coverage, claims conditions, and commercial arrangements for Gooval and insurance partnership products are governed by official product terms. The Platform does not guarantee any specific business outcome or return.',
          'On-Chain Data blockchain verification depends on merchant authorization, data synchronization, encryption, and on-chain recording, and may involve <strong>data delays, network or node volatility, authorization limits, and differences in third-party verification results</strong>. It does not constitute any financing, credit, or investment commitment.',
          'You may suffer business losses due to market changes, service interruptions, data delays, or third-party issues. To the extent permitted by law, the Platform is not liable for direct or indirect losses arising from use of website information or third-party products.'
        ]
      },
      intellectualProperty: {
        title: '6. Intellectual Property',
        content: 'All content on this website, including text, images, logos, product descriptions, and interface design, is protected by copyright and other intellectual property laws. Unauthorized reproduction, distribution, modification, or commercial use is prohibited. Trademarks and names of Gooval, On-Chain Data, and partner products belong to their respective owners.'
      },
      amendments: {
        title: '7. Amendments to Terms',
        content: 'We reserve the right to modify or update these Terms at any time. The latest version will be published on this website, and continued use constitutes acceptance of the updated Terms.'
      },
      governingLaw: {
        title: '8. Governing Law',
        content: 'These Terms shall be governed by and construed in accordance with the laws of the <strong>Hong Kong Special Administrative Region</strong>. Any disputes shall be subject to the exclusive jurisdiction of the courts of Hong Kong'
      }
    },
    declaration: '<strong>Disclaimer: </strong>By accessing or using the Platform, you confirm that you have read, understood, and agreed to these Terms of Use'
  },

  // Compliance Disclaimer page
  complianceDisclaimer: {
    title: 'Compliance & Security',
    sections: {
      informationPurpose: {
        title: '1. Purpose of Information',
        content: 'All content on this website, including company information, service descriptions, product showcases, partnership links, and documents (the "Information"), is provided for <strong>general reference and business communication only</strong>. The Information does <strong>not</strong> constitute, and shall not be construed as:',
        points: [
          'An offer to sell, solicitation of an offer to buy, or recommendation to acquire any financial instrument, security, token, insurance contract, or other regulated product',
          'Legal, financial, tax, insurance, or investment advice of any kind',
          'An inducement or invitation to participate in any transaction in any jurisdiction where such offer or solicitation would be unlawful'
        ]
      },
      noInvestmentOffer: {
        title: '2. Service and Product Disclaimer',
        content: 'The logistics, freight forwarding, warehousing, Gooval shipping and buyer protection product, insurance partnership products, and On-Chain Data blockchain verification services introduced on this website are subject to formal agreements, partner product pages, app store terms, or official documentation covering service scope, fees, coverage, claims rules, data authorization, and technical integration. The Platform makes no warranty regarding the accuracy, completeness, or continued availability of third-party product pages.'
      },
      investorEligibility: {
        title: '3. Eligibility Requirements',
        content1: 'Platform services are primarily intended for cross-border e-commerce merchants, logistics and supply chain partners, and qualified institutional collaborators. Certain products or partnership programs may be limited to <strong>qualified institutions, professional investors, or business clients</strong> under applicable law, for example:',
        examples: [
          '<strong>Hong Kong</strong>: Insurance or financial-related products may be limited to "Professional Investors" under the Securities and Futures Ordinance (Cap. 571) or other compliant client categories',
          '<strong>Singapore</strong>: Certain institutional services may be limited to "Accredited Investors" under the Securities and Futures Act',
          '<strong>European Union</strong>: Certain institutional services may be limited to "Professional Clients" under MiFID II'
        ],
        content2: 'Where merchant onboarding, insurance partnerships, On-Chain Data authorization, fund custody, or higher-risk services are involved, relevant parties must complete <strong>Know Your Customer (KYC)</strong> and <strong>Anti-Money Laundering (AML)</strong> procedures as required by the Platform or partners.'
      },
      geographicRestrictions: {
        title: '4. Jurisdictional Restrictions',
        content: 'Certain partnership products or services may not be offered to residents or users in the following jurisdictions, including but not limited to:',
        restrictions: [
          'Retail and non-professional investors in the <strong>Hong Kong Special Administrative Region</strong>, where products are limited to professional investors',
          'Residents of the <strong>People\'s Republic of China</strong> (excluding Hong Kong, Macau, and Taiwan), where local law imposes additional restrictions',
          'The <strong>United States, Canada, India, South Korea</strong>, and any other jurisdiction where similar products or services are prohibited by law'
        ],
        warning: 'Any attempt to access or use relevant services in violation of applicable law or product eligibility requirements may result in service termination, with legal responsibility borne by the user.'
      },
      riskDisclosure: {
        title: '5. Risks and Disclaimers',
        content: 'Cross-border e-commerce services involve logistics fulfillment, customs coordination, warehousing, buyer protection, insurance partnerships, and On-Chain Data blockchain verification, which may carry <strong>transport delays, cargo loss, policy changes, system interruptions, data delays, on-chain recording volatility, partner performance, and regulatory risks</strong>. The Platform does not guarantee uninterrupted service, business returns, credit outcomes, or claim outcomes, and is not responsible for third-party product pages, APIs, apps, or external links.'
      },
      rightsReservation: {
        title: '6. Reservation of Rights',
        content: 'The Platform reserves the right, at its sole discretion, to:',
        rights: [
          'Refuse service to individuals or entities that do not meet eligibility, compliance, or business review requirements',
          'Modify, suspend, or terminate any service introduction, partnership link, or product integration description',
          'Update this compliance statement and website content as required by law, regulation, partner requirements, or business needs'
        ]
      },
      governingLaw: {
        title: '7. Governing Law',
        content: 'This Compliance Disclaimer shall be governed by and construed in accordance with the laws of the <strong>Hong Kong Special Administrative Region</strong>.'
      }
    },
    declaration: '<strong>Notice: </strong>By accessing or using this website, you acknowledge that you have read, understood, and agreed to comply with this Compliance & Security statement.'
  },

  // White Paper page
  whitePaper: {
    title: 'Gwofy: Cross-Border E-Commerce Service Provider',
    version: 'Version: v2.1',
    sections: {
      vision: {
        title: '1. Vision and Positioning',
        content1: 'Gwofy is a <strong>comprehensive service provider</strong> for the cross-border e-commerce ecosystem, offering logistics, freight forwarding, overseas warehousing, buyer protection, and blockchain verification capabilities for merchants and institutional partners.',
        content2: 'Through <strong>Gooval</strong>, <strong>insurance partnership programs</strong>, and <strong>On-Chain Data</strong>, we help merchants improve fulfillment experience, reduce post-sale disputes, and strengthen transparency and trust for cross-border commerce and receivables data.',
        disclaimer: 'This document is for business introduction only. It does not constitute an investment offer, insurance offer, or financing invitation. Specific product terms are governed by formal agreements and official partner documentation.'
      },
      marketBackground: {
        title: '2. Market Background',
        content1: 'As DTC brands, Shopify merchants, and multi-platform sellers expand globally, they commonly face the following challenges:',
        painPoints: [
          '**Complex logistics fulfillment:** Cross-border transport, last-mile delivery, and tracking are difficult to manage in one place',
          '**High supply chain coordination costs:** First-mile transport, customs clearance, and trunk line connectivity require professional freight support',
          '**Warehouse pressure:** Peak-season inventory, turnover, and multi-site coordination strain operations',
          '**Post-sale and risk costs:** Lost, damaged, or returned shipments and lack of protection affect conversion and brand trust',
          '**Insufficient data trust:** Cross-border receivables and core operating data often lack real-time, verifiable proofs, slowing institutional collaboration'
        ],
        content2: 'Merchants and partners need more than point solutions. They need integrated capabilities across <strong>logistics, warehousing, buyer protection, insurance partnerships, and on-chain verification</strong> to support stable international growth.'
      },
      coreServices: {
        title: '3. Core Service Capabilities',
        content: 'Gwofy provides the following integrated services across the cross-border commerce and fulfillment chain:',
        logistics: {
          title: '3.1 Cross-Border Logistics',
          contents: [
            'Last-mile delivery, transit lanes, and end-to-end tracking',
            'Built for DTC, Shopify, and multi-platform merchant fulfillment needs',
            'Improves delivery transparency and buyer experience'
          ]
        },
        freight: {
          title: '3.2 Freight Forwarding',
          contents: [
            'First-mile transport, customs coordination, and multi-channel trunk line connectivity',
            'Helps merchants reduce cross-border supply chain coordination costs',
            'Supports different destinations and transport mode combinations'
          ]
        },
        warehouse: {
          title: '3.3 Warehousing',
          contents: [
            'Overseas inventory, inbound/outbound operations, and stock coordination',
            'Supports peak-season stocking and multi-site operations',
            'Improves inventory visibility and fulfillment efficiency'
          ]
        }
      },
      gooval: {
        title: '4. Gooval Product',
        content: 'Gooval is Gwofy\'s <strong>logistics and buyer protection</strong> product for cross-border and DTC merchants, providing shipping protection and post-sale benefit capabilities.',
        features: {
          title: '4.1 Core Capabilities',
          points: [
            '**Shipping protection:** Coverage for lost, damaged, and stolen packages',
            '**Buyer benefit package:** Returns, exchanges, and extended warranty options that improve shopping experience',
            '**Merchant-friendly model:** Shoppers opt in to protection, reducing merchant integration and support burden'
          ]
        },
        integration: {
          title: '4.2 Integration Options',
          contents: [
            '**Shopify app:** Install via the Shopify App Store: <a href="https://apps.shopify.com/gooval-shipping-protection" target="_blank">Gooval Shipping Protection</a>',
            '**Open API:** Connect custom storefronts and internal systems via documented APIs: <a href="https://www.gooval.io/docs/open-api#overview" target="_blank">Open API Docs</a>',
            'Designed for DTC and cross-border merchants that want to launch shipping protection and buyer benefits quickly'
          ]
        }
      },
      insurance: {
        title: '5. Insurance Partnership Product',
        content: 'Gwofy works with partners such as Cathay Insurance to provide insurance solutions for cross-border logistics and commerce scenarios.',
        contents: [
          'Insurance partnership capabilities for cross-border logistics and e-commerce use cases',
          'Strengthens trust and risk management across trade and fulfillment',
          'Learn more on the official page: <a href="https://jw.hedejj.com/" target="_blank">https://jw.hedejj.com/</a>'
        ],
        note: 'Coverage scope, claims conditions, pricing, and eligible users are governed by official partner terms and regulatory requirements.'
      },
      onChainData: {
        title: '6. On-Chain Data Blockchain Verification',
        content: 'On-Chain Data is Gwofy\'s <strong>blockchain verification service</strong> for cross-border e-commerce receivables and core transaction data. It creates tamper-resistant proofs that improve transparency and institutional trust.',
        features: {
          title: '6.1 Core Capabilities',
          points: [
            '**Data authorization and on-chain recording:** With merchant authorization, core operating data can be synced via API, encrypted, and recorded on-chain for authenticity and immutability',
            '**Receivables verification:** On-chain verification of receivables generates trusted proofs and reduces information asymmetry',
            '**Real-time institutional verification:** Partners can independently verify merchant data to improve credit and risk workflows',
            '**Multi-chain support:** Supports public chain ecosystems including Ethereum, Polygon, Solana, and Avalanche'
          ]
        },
        access: {
          title: '6.2 Access and Verification',
          contents: [
            'Merchants and partners can review on-chain data and verification results via the Platform <a href="/on-chain-data">On-Chain Data</a> page',
            'Service scope, data authorization terms, update frequency, and verification permissions are governed by formal agreements and Platform documentation',
            'On-Chain Data provides verification and transparency capabilities only and <strong>does not constitute a financing, credit, investment, or other financial product offer</strong>'
          ]
        }
      },
      compliance: {
        title: '7. Compliance and Data Security',
        dataPrivacy: {
          title: '7.1 Data and Privacy',
          contents: [
            'Follows applicable data protection and privacy requirements, including GDPR and Hong Kong\'s Personal Data (Privacy) Ordinance',
            'Processes business, service, and on-chain verification data only within the scope of merchant authorization',
            'Applies reasonable safeguards to sensitive data, including encryption and on-chain handling within authorized scope'
          ]
        },
        partnerCompliance: {
          title: '7.2 Partnership and Compliance',
          contents: [
            'KYC/AML and other compliance reviews are completed where required for merchant onboarding, insurance partnerships, On-Chain Data authorization, or higher-risk services',
            'Third-party products and services follow the regulatory and product rules of their respective partners',
            'The Platform continuously improves service processes to operate within lawful and compliant frameworks'
          ]
        }
      },
      cooperationEcosystem: {
        title: '8. Ecosystem and Outlook',
        contents: [
          '**E-commerce platform partnerships:** Shopify app and API integrations',
          '**Logistics and warehousing partnerships:** Expanding trunk lines, overseas warehouses, and fulfillment networks',
          '**Insurance and financial partnerships:** Working with partners such as Cathay Insurance to strengthen cross-border protection',
          '**Data and institutional partnerships:** Enabling qualified institutions to verify operating and receivables data through On-Chain Data'
        ],
        note: 'Gwofy will continue to strengthen its cross-border e-commerce service capabilities and provide merchants and partners with a more stable, scalable foundation for global expansion.'
      },
      futureVision: {
        title: '9. Mission and Vision',
        contents: [
          '**Mission:** Connect cross-border merchants, logistics networks, protection systems, and trusted data through professional services to make global expansion more stable and trustworthy',
          '**Vision:** Become a trusted comprehensive service provider and productized capability platform in cross-border e-commerce'
        ]
      },
      legalDisclaimer: {
        title: '10. Compliance Disclaimer and Restrictions',
        contents: [
          'This document is for business introduction only and does not constitute any investment, insurance, or financing offer',
          'Specific terms for Gooval, insurance partnerships, On-Chain Data, and other products are governed by formal agreements and official partner documentation',
          'Certain products or services may not be offered to ineligible users in the following regions:'
        ],
        restrictions: [
          'Retail and non-professional investors in Hong Kong SAR, where products are limited to professional investors',
          'The People\'s Republic of China (excluding Hong Kong, Macau, and Taiwan), where local law prohibits participation',
          'The United States, Canada, India, South Korea, and any other restricted regions under local law'
        ]
      },
      contact: {
        title: '11. Contact',
        info: [
          'Website: <a href="https://hk.gwofy.com/" target="_blank">https://hk.gwofy.com/</a>',
          'Email: <a href="mailto:contact@gwofy.com" target="_blank">contact@gwofy.com</a>',
          'Address: 12/F, Shing Lee Yuen Building, 71 Bonham Strand West, Sheung Wan, Hong Kong'
        ]
      }
    }
  }
}
